/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const portionNutritionSchema = z
	.object({
		weight: z.number().nullable(),
		measure_unit: z.string().nullable(),
		fat_amount: z.number().nullable(),
		proteins_amount: z.number().nullable(),
		carbohydrates_amount: z.number().nullable(),
		energy_amount: z.number().nullable(),
	})
	.describe("Вес и КБЖУ порции");
